(function () {
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileViewportQuery = window.matchMedia('(max-width: 767px)');
  var cloneAttribute = 'data-alilao-clone';
  var initializedAttribute = 'data-alilao-carousel-initialized';
  var defaultRotateRate = 5000;
  var autoRotateResumeDelay = 1200;
  var slideTransitionDuration = 400;

  function shouldDisableMotion() {
    return reduceMotionQuery.matches;
  }

  function isAutoRotateEnabled(viewport) {
    return viewport && String(viewport.getAttribute('data-categories-auto-rotate')) === 'true';
  }

  function getRotateRate(viewport) {
    var rate = viewport ? parseInt(viewport.getAttribute('data-categories-rotate-rate'), 10) : 0;

    if (!rate || rate < 1) {
      return defaultRotateRate;
    }

    return rate;
  }

  function syncMobileViewportMetrics(viewport, track) {
    if (!viewport || !track) {
      return;
    }

    if (!mobileViewportQuery.matches) {
      viewport.style.removeProperty('--alilao-categories-mobile-item-width');
      return;
    }

    var trackStyles = window.getComputedStyle(track);
    var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
    var itemWidth = Math.max(0, (viewport.clientWidth - gap) / 2);

    viewport.style.setProperty('--alilao-categories-mobile-item-width', itemWidth + 'px');
  }

  function getItemDistance(track) {
    var firstItem = track ? track.querySelector('.alilao-categories-item:not([' + cloneAttribute + '="true"])') : null;

    if (!firstItem) {
      return 148;
    }

    var itemStyles = window.getComputedStyle(firstItem);
    var trackStyles = track ? window.getComputedStyle(track) : null;
    var itemWidth = firstItem.getBoundingClientRect().width;
    var gap = trackStyles ? parseFloat(trackStyles.columnGap || trackStyles.gap || '0') : 0;
    var margins = parseFloat(itemStyles.marginLeft || '0') + parseFloat(itemStyles.marginRight || '0');

    return Math.round(itemWidth + gap + margins) || 148;
  }

  function markCloneItem(item) {
    item.setAttribute(cloneAttribute, 'true');
    item.setAttribute('aria-hidden', 'true');

    var focusable = item.querySelectorAll('a, button, input, select, textarea, [tabindex]');

    for (var index = 0; index < focusable.length; index += 1) {
      focusable[index].setAttribute('tabindex', '-1');
    }
  }

  function ensureLoopContent(track) {
    if (!track || track.getAttribute('data-alilao-loop-ready') === 'true') {
      return;
    }

    var originalItems = Array.prototype.slice.call(track.children);

    if (!originalItems.length) {
      return;
    }

    for (var index = 0; index < originalItems.length; index += 1) {
      var clone = originalItems[index].cloneNode(true);
      markCloneItem(clone);
      track.appendChild(clone);
    }

    track.setAttribute('data-alilao-loop-ready', 'true');
  }

  function removeLoopContent(track) {
    if (!track) {
      return;
    }

    var clones = track.querySelectorAll('[' + cloneAttribute + '="true"]');

    for (var index = 0; index < clones.length; index += 1) {
      clones[index].parentNode.removeChild(clones[index]);
    }

    track.removeAttribute('data-alilao-loop-ready');
  }

  function setupAutoScroll(viewport) {
    if (!viewport || viewport.getAttribute(initializedAttribute) === 'true') {
      return;
    }

    viewport.setAttribute(initializedAttribute, 'true');

    var paused = false;
    var track = viewport.querySelector('.alilao-categories-track');
    var loopWidth = 0;
    var itemDistance = 0;
    var rotateRate = getRotateRate(viewport);
    var autoRotateTimer = null;
    var resumeTimer = null;
    var isAutoAdvancing = false;

    function hasScrollableOverflow() {
      return viewport.scrollWidth - viewport.clientWidth > 1;
    }

    function hasBaseOverflow() {
      removeLoopContent(track);
      viewport.scrollLeft = 0;

      return viewport.scrollWidth - viewport.clientWidth > 1;
    }

    function updateLoopWidth() {
      if (!track) {
        loopWidth = 0;
        return;
      }

      loopWidth = track.scrollWidth / 2;
    }

    function clearResumeTimer() {
      if (resumeTimer) {
        window.clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function stopAutoRotate() {
      if (autoRotateTimer) {
        window.clearTimeout(autoRotateTimer);
        autoRotateTimer = null;
      }
    }

    function normalizeScrollPosition() {
      if (!loopWidth) {
        return;
      }

      if (viewport.scrollLeft >= loopWidth) {
        viewport.scrollLeft -= loopWidth;
      } else if (viewport.scrollLeft < 0) {
        viewport.scrollLeft += loopWidth;
      }
    }

    function shouldAutoRotateNow() {
      return !shouldDisableMotion() && !paused && isAutoRotateEnabled(viewport) && hasScrollableOverflow() && itemDistance > 0;
    }

    function scheduleNextStep() {
      stopAutoRotate();

      if (!shouldAutoRotateNow()) {
        return;
      }

      autoRotateTimer = window.setTimeout(function () {
        advanceSlide();
      }, rotateRate);
    }

    function advanceSlide() {
      stopAutoRotate();

      if (!shouldAutoRotateNow()) {
        return;
      }

      isAutoAdvancing = true;
      viewport.scrollTo({
        left: viewport.scrollLeft + itemDistance,
        behavior: 'smooth'
      });

      window.setTimeout(function () {
        normalizeScrollPosition();
        isAutoAdvancing = false;
      }, slideTransitionDuration);

      scheduleNextStep();
    }

    function syncLoopState() {
      if (!track) {
        loopWidth = 0;
        itemDistance = 0;
        return;
      }

      syncMobileViewportMetrics(viewport, track);
      rotateRate = getRotateRate(viewport);
      itemDistance = getItemDistance(track);

      if (isAutoRotateEnabled(viewport) && hasBaseOverflow()) {
        ensureLoopContent(track);
        updateLoopWidth();
      } else {
        removeLoopContent(track);
        viewport.scrollLeft = 0;
        loopWidth = 0;
      }
    }

    function setPaused(value) {
      paused = value;

      if (paused) {
        stopAutoRotate();
      } else {
        scheduleNextStep();
      }
    }

    function pauseAndResumeAfterInteraction() {
      clearResumeTimer();
      stopAutoRotate();
      paused = true;

      resumeTimer = window.setTimeout(function () {
        paused = false;
        scheduleNextStep();
      }, autoRotateResumeDelay);
    }

    syncLoopState();
    window.addEventListener('resize', function () {
      syncLoopState();
      scheduleNextStep();
    });

    viewport.addEventListener('mouseenter', function () {
      setPaused(true);
    });

    viewport.addEventListener('mouseleave', function () {
      setPaused(false);
    });

    viewport.addEventListener('focusin', function () {
      setPaused(true);
    });

    viewport.addEventListener('focusout', function (event) {
      if (!viewport.contains(event.relatedTarget)) {
        setPaused(false);
      }
    });

    viewport.addEventListener('touchstart', function () {
      pauseAndResumeAfterInteraction();
    }, { passive: true });

    viewport.addEventListener('touchend', function () {
      pauseAndResumeAfterInteraction();
    }, { passive: true });

    viewport.addEventListener('scroll', function () {
      normalizeScrollPosition();

      if (!paused && !isAutoAdvancing) {
        pauseAndResumeAfterInteraction();
      }
    }, { passive: true });

    normalizeScrollPosition();
    scheduleNextStep();
  }

  function initCategoriesCarousel(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var viewports = scope.querySelectorAll('[data-alilao-categories-track]');

    for (var index = 0; index < viewports.length; index += 1) {
      setupAutoScroll(viewports[index]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCategoriesCarousel(document);
    });
  } else {
    initCategoriesCarousel(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      initCategoriesCarousel(event.target);
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target) {
      initCategoriesCarousel(event.target);
    }
  });
})();